import ExcelIcon from '@account-root/account-react/src/assets/icons/excel-white.svg'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import { InputUpload } from '@ifca-root/react-component/src/components/Input/InputUpload'
import SnackBarMsg from '@ifca-root/react-component/src/components/SnackBar/SnackBarMsg'
import IconText from '@ifca-root/react-component/src/components/Typography/IconText'
import { Button, List, ListItem, ListItemText } from '@material-ui/core'
import React from 'react'

interface ISnackBarProps {
  openSnackBar: boolean
  snackBarMessage: string
  setOpenSnackBar?: React.Dispatch<boolean>
  onClickButton?: any
  label?: string
}
interface IBatchExcelInputProps {
  openUpload: boolean
  setOpenUpload: any
  upload: string
  template: any
  onDownloadTemplate: any
  onSelectFile: any
  setUpload: any
  setTemplate: any
  onUploadTemplate: any
  snackBarProps: ISnackBarProps
  showDupErrors?: boolean
  duplicateItems?: any
  errorDia?: boolean
  setErrorDia?: React.Dispatch<boolean>
  resetFileUpload?: any
  showFooter?: boolean
  date?: Date
  setDate?: any
  description?: string
  setDescription?: any
  IsExcelMatch?: boolean
  setIsOB?: any
  StatementBalance?: number
  setStatementBalance?: any
  onCreateWihoutExcel?: any
  onUpdateWihoutExcel?: any
  editValue?: any
  reUpload?: boolean
  labelDisplay?: string
}

export interface BankReconciliationProps {
  BankReconciliationID: String
  CompanyID: String
  BankAccountID: String
  DocumentDate: String
  Remarks: String
}

export const BatchExcelInput = (props: IBatchExcelInputProps) => {
  const {
    openUpload,
    setOpenUpload,
    upload,
    onDownloadTemplate,
    onSelectFile,
    setUpload,
    setTemplate,
    onUploadTemplate,
    snackBarProps,
    duplicateItems,
    showDupErrors,
    errorDia,
    setErrorDia,
    resetFileUpload,
    editValue,
    labelDisplay,
  } = props

  const {
    openSnackBar,
    snackBarMessage,
    setOpenSnackBar,
    onClickButton,
    label,
  } = snackBarProps

  return (
    <div>
      {showDupErrors && errorDialog(errorDia, setErrorDia, duplicateItems)}
      <CommonDialog
        fullWidth={true}
        open={openUpload}
        onClose={() => {
          resetFileUpload()
          setUpload('')
          setTemplate([])
          setOpenUpload(false)
        }}
        sections={{
          header: {
            title: labelDisplay,
            rightText: 'Upload',
          },
          body: () => (
            <>
              <InputUpload
                accept={'.xlsx, .xls, .cxv'}
                value={upload}
                label={`${labelDisplay} Upload`}
                required={!editValue ? true : false}
                multiline={true}
                handleUpload={e => onSelectFile(e)}
                className="p-b-20"
              />
            </>
          ),
          leftFooterIcon: (
            <span style={{ width: '100%' }}>
              <Button
                variant="contained"
                size="small"
                className="btn-dialog btn-primary"
                onClick={() => {
                  onDownloadTemplate()
                }}
                style={{
                  float: 'left',
                }}
                color="primary"
              >
                <IconText
                  icon={
                    <img
                      src={ExcelIcon}
                      style={{ width: '19px', paddingRight: '5px' }}
                    />
                  }
                  font="mdDesc"
                  children={'Download'}
                />
              </Button>
            </span>
          ),
          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => [
                    setOpenUpload(false),
                    setUpload(''),
                    setTemplate([]),
                    resetFileUpload(),
                  ],
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => {
                    onUploadTemplate()
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />

      <SnackBarMsg
        open={openSnackBar}
        message={snackBarMessage}
        setOpen={setOpenSnackBar}
        label={label}
        onClickButton={onClickButton}
      />
    </div>
  )
}

const errorDialog = (
  openErrDialog: boolean,
  setOpenErrDia: React.Dispatch<boolean>,
  duplicateItems: string[]
) => (
  <CommonDialog
    fullWidth={true}
    open={openErrDialog}
    onClose={() => {
      setOpenErrDia(false)
    }}
    sections={{
      header: { title: 'Item(s) exists' },
      body: () => (
        <>
          <div>
            <span className="mdDesc text-noflow">
              Unable to upload the following item(s).
              <List>
                {duplicateItems?.map((v, i) => (
                  <ListItem key={i}>
                    <ListItemText
                      style={{ height: '10px' }}
                      primary={
                        <span className="mdDesc flex-space">{`- ${v}`}</span>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </span>
            <span className="desc text-noflow">
              Please remove duplicated items and try again.
            </span>
          </div>
        </>
      ),
      footer: {
        actions: [
          {
            displayText: 'Close',
            props: {
              onClick: () => {
                setOpenErrDia(false)
              },
              variant: 'contained',
              color: 'primary',
            },
          },
        ],
      },
    }}
  />
)
